import React from 'react';
import { Category, Banner as CategoryBanner } from 'types/Category';
import { DeviceSize, useWindowSize } from 'hooks/useWindowSize';
import Banner from './Banner';

export const getBannerImageForPageSize = (deviceSize: string, banner: CategoryBanner): string => {
  if (deviceSize === DeviceSize.SMALL) {
    return banner.bannerImageMobile;
  } else if (deviceSize === DeviceSize.MEDIUM) {
    return banner.bannerImageTablet;
  } else {
    return banner.bannerImageDesktop;
  }
};

interface CategoryBannerProps {
  category: Category & {
    topBanner: CategoryBanner & {
      legacyTopBannerBlock: string;
    };
    bottomBanner: CategoryBanner & {
      legacyBannerBlock: string;
    };
  };
}

export function TopCategoryBanner({ category }: CategoryBannerProps): React.JSX.Element {
  const { deviceSize } = useWindowSize();
  const topBanner = category.topBanner;
  return (
    <Banner
      img={getBannerImageForPageSize(deviceSize, topBanner)}
      alt={topBanner.bannerImageAlt}
      legacyBlock={topBanner.legacyTopBannerBlock}
    />
  );
}

export function BottomCategoryBanner({ category }: CategoryBannerProps): React.JSX.Element {
  const { deviceSize } = useWindowSize();
  const bottomBanner = category.bottomBanner;
  return (
    <Banner
      img={getBannerImageForPageSize(deviceSize, bottomBanner)}
      alt={bottomBanner.bannerImageAlt}
      legacyBlock={bottomBanner.legacyBannerBlock}
    />
  );
}
